/**
 * Lista ordenada de endpoints GraphQL: [principal, respaldo?].
 * El respaldo (Railway) solo existe si VITE_API_URL_BACKUP está definida —
 * esa env var ES el flag de activación del failover (Fase 2 URL de respaldo).
 */
export function getApiEndpoints(): string[] {
  const primary = import.meta.env.VITE_API_URL;
  const backup = import.meta.env.VITE_API_URL_BACKUP;
  const list = [primary, backup].filter(
    (u): u is string => typeof u === 'string' && u.length > 0,
  );
  const endpoints = [...new Set(list)];
  if (endpoints.length === 0) {
    console.error('[apiEndpoints] VITE_API_URL ausente — usando /graphql relativo');
    return ['/graphql'];
  }
  for (const endpoint of endpoints) {
    if (!/\/graphql\/?$/.test(endpoint)) {
      console.warn(
        `[apiEndpoints] "${endpoint}" no termina en /graphql — healthUriFor no podrá derivar su /health (failover inoperante para este endpoint).`,
      );
    }
  }
  return endpoints;
}

/** https://host/graphql → https://host/health (probe barato, sin caché). */
export function healthUriFor(graphqlUri: string): string {
  return graphqlUri.replace(/\/graphql\/?$/, '/health');
}
